var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import firebase from "firebase/app";
import { useEffect, useState } from "react";
/**
 * Returns an array of printers that may be used. Options further allow refinement of the returned set to adapt to
 * task-specific hardware needs. Options are exercised client-side.
 *
 * @returns [Printer[] | null] An array of printers. Null while still loading.
 */
export default function usePrinters(options) {
    var _this = this;
    var _a = useState(null), printers = _a[0], setPrinters = _a[1];
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setPrinters;
                        return [4 /*yield*/, getPrinters(options)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [options]);
    return printers;
}
export function getPrinters(options) {
    var _a;
    return __awaiter(this, void 0, Promise, function () {
        var uid, documents, printerCandidates;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    uid = (_a = firebase.auth().currentUser) === null || _a === void 0 ? void 0 : _a.uid;
                    if (!uid) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, firebase
                            .firestore()
                            .collection("printers")
                            .where("ownerId", "==", uid)
                            .get()];
                case 1:
                    documents = _b.sent();
                    printerCandidates = documents.docs.map(function (d) { return d.data(); });
                    // Apply filters
                    if (options) {
                        if (options.locationsOnly !== undefined) {
                            printerCandidates = printerCandidates.filter(function (p) { var _a; return ((_a = options.locationsOnly) !== null && _a !== void 0 ? _a : []).includes(p.locationId); });
                        }
                        if (options.requiredCapabilities) {
                            printerCandidates = printerCandidates.filter(function (p) {
                                var _a;
                                return ((_a = options.requiredCapabilities) !== null && _a !== void 0 ? _a : []).reduce(function (accu, curr) {
                                    // If one requirement is already violated, don't check further
                                    if (!accu)
                                        return false;
                                    // Check that the current requirement is met.
                                    return p.capabilities.includes(curr);
                                }, true);
                            });
                        }
                    }
                    // Finally, set the new set of printers
                    return [2 /*return*/, printerCandidates];
            }
        });
    });
}
